/* eslint-disable */
export default {
  from: 'De',
  to: 'À',
  enterNameOrNumber: 'Saisir le numéro ou le nom…',
  typeMessage: 'Saisir un message...',
  send: 'Envoyer',
  emoji: 'Émoji',
} as const;

// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number or Name..."@#@
// @key: @#@"typeMessage"@#@ @source: @#@"Type message..."@#@
// @key: @#@"send"@#@ @source: @#@"Send"@#@
// @key: @#@"emoji"@#@ @source: @#@"Emoji"@#@
